<form #policiesForm="ngForm">
  <div class="toolbar">
    <span>
      <button matButton="text" (click)="backToOrganizationDetail()">
        <span>
          <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
          <label>Back To Organization</label>
        </span>
      </button>
    </span>
    <span class="spacer"></span>
    <span>
      @if (!isNew() && customers() && customers().length > 0) {
        <button matButton="text" (click)="newPolicy()">
          <span>
            <mat-icon class="size-16">add</mat-icon>
            <label>New</label>
          </span>
        </button>
      }
      <button matButton="text" [disabled]="!selectedPolicy || policiesForm.invalid" (click)="save()">
        <span>
          <mat-icon class="size-16">done</mat-icon>
          <label>Save</label>
        </span>
      </button>
    </span>
  </div>
  <div class="policiesWrapper">
    <div class="leftColumn">
      <table class="reportTable">
        <thead>
          <tr>
            <td class="tableCell headerCell">Customer ID</td>
            <td class="tableCell headerCell">Customer Name</td>
          </tr>
        </thead>
        @if (policies() && policies().length > 0) {
          @for (policy of policies(); track policy; let rowIndex = $index) {
            <tr [class.selectedRow]="rowIndex === selectedRowId()" class="selectableRow" (click)="selectPolicy(rowIndex, policy)">
              <td class="tableCell">{{ policy.customerId }}</td>
              <td class="tableCell">{{ policy.customerName }}</td>
            </tr>
          }
        }
        @if (!policies() || policies().length === 0) {
          <tr>
            <td class="tableCell centeredCell" colspan="2">No policies found</td>
          </tr>
        }
      </table>
    </div>
    <div class="rightColumn">
      @if (selectedPolicy) {
        <table>
          @if (isNew()) {
            <tr>
              <td class="labelColumn">
                <label for="customerSelection">Customer:</label>
              </td>
              <td class="inputColumn">
                <select name="customerSelection" id="customerSelection" class="inputField" [(ngModel)]="selectedPolicy.customerId">
                  @for (customer of customers(); track customer) {
                    <option [value]="customer.code">{{ customer.description }}</option>
                  }
                </select>
              </td>
            </tr>
          }
          <tr>
            <td class="labelColumn">
              <label for="approvedAmountInput">Approved Amount:</label>
            </td>
            <td class="inputColumn">
              <input id="approvedAmountInput" name="approvedAmountInput" class="inputField standardTextBox" maxlength="15" [ngClass]="{'inputError': approvedAmountInput.invalid}" required pattern="^\d+(.\d{2})?$"
                [(ngModel)]="selectedPolicy.approvedAmount" #approvedAmountInput="ngModel"/>
            </td>
          </tr>
          <tr>
            <td class="labelColumn">
              <label for="customerAccountInput">Customer AR Account:</label>
            </td>
            <td class="inputColumn">
              <input id="customerAccountInput" name="customerAccountInput" class="inputField standardTextBox" maxlength="50" [(ngModel)]="selectedPolicy.defaultArGlAccountId"/>
            </td>
          </tr>
          <tr>
            <td class="labelColumn">
              <label for="orderLimitInput">Per Order Limit:</label>
            </td>
            <td class="inputColumn">
              <input id="orderLimitInput" name="orderLimitInput" class="inputField standardTextBox" maxlength="15" [ngClass]="{'inputError': orderLimitInput.invalid}" required pattern="^\d+(.\d{2})?$"
                [(ngModel)]="selectedPolicy.defaultPerOrderCreditLimit" #orderLimitInput="ngModel"/>
            </td>
          </tr>
          <tr>
            <td class="labelColumn">
              <label for="creditLimitInput">Credit Limit:</label>
            </td>
            <td class="inputColumn">
              <input id="creditLimitInput" name="creditLimitInput" class="inputField standardTextBox" maxlength="15" [ngClass]="{'inputError': creditLimitInput.invalid}" required pattern="^\d+(.\d{2})?$"
                [(ngModel)]="selectedPolicy.creditLimit" #creditLimitInput="ngModel"/>
            </td>
          </tr>
          <tr>
            <td class="labelColumn">
              <label for="creditCheckContractInput">Order Review Credit Check:</label>
            </td>
            <td class="inputColumn">
              <input type="checkbox" id="creditCheckContractInput" name="creditCheckContractInput" [(ngModel)]="selectedPolicy.creditCheckAtContractConfirm"/>
            </td>
          </tr>
          <tr>
            <td class="labelColumn">
              <label for="creditHoldInput">Credit Hold:</label>
            </td>
            <td class="inputColumn">
              <input type="checkbox" id="creditHoldInput" name="creditHoldInput" [(ngModel)]="selectedPolicy.creditHold"/>
            </td>
          </tr>
          <tr>
            <td class="labelColumn">
              <label for="creditCheckSelection">Credit Check Method:</label>
            </td>
            <td class="inputColumn">
              <select name="creditCheckSelection" id="creditCheckSelection" class="inputField" [(ngModel)]="selectedPolicy.customerCreditCheckMethodCode">
                @for (creditCheck of creditCheckMethods(); track creditCheck) {
                  <option [value]="creditCheck.code">{{ creditCheck.description }}</option>
                }
              </select>
            </td>
          </tr>
          <tr>
            <td class="labelColumn">
              <label for="creditLevelSelection">Credit Level Check:</label>
            </td>
            <td class="inputColumn">
              <select name="creditLevelSelection" id="creditLevelSelection" class="inputField" [(ngModel)]="selectedPolicy.defaultCreditLevelCheckingCode">
                @for (creditLevel of creditLevelChecks(); track creditLevel) {
                  <option [value]="creditLevel.code">{{ creditLevel.description }}</option>
                }
              </select>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="inputColumn"><label>Created: {{ selectedPolicy.createUser }} - {{ selectedPolicy.createTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</label></td>
          </tr>
          <tr>
            <td colspan="2" class="inputColumn"><label>Updated: {{ selectedPolicy.updateUser }} - {{ selectedPolicy.updateTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</label></td>
          </tr>
        </table>
      }
    </div>
  </div>
</form>
